/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_UnknownInputs */

const en_user_unknown = /** @type {(inputs: User_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown user`)
};

const pt_br2_user_unknown = /** @type {(inputs: User_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown user" |
*
* @param {User_UnknownInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const user_unknown = /** @type {((inputs?: User_UnknownInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_UnknownInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_unknown(inputs)
	return pt_br2_user_unknown(inputs)
});